const {client, loadToken} = require('./client');
export { loadToken };

export async function getWeather(latitude, longitude){
    var {data} = await client.get(`/weather/current/${latitude}/${longitude}`);

    return data;
}
